import { useEffect, useState } from 'react';

/**
 * Retarde l'expansion de largeur d'un panneau latéral d'une frame
 * pour que la transition CSS w-0 → w-[52%] s'exécute à l'ouverture.
 */
export function usePanelWidthTransition(isOpen: boolean) {
  const [isWidthExpanded, setIsWidthExpanded] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    // L'état part toujours de `false` (initial, ou remis à false par le cleanup
    // de la fermeture précédente), donc pas besoin de setState synchrone ici :
    // on programme l'expansion à la 2ᵉ frame pour déclencher la transition CSS.
    let expandFrame = 0;
    const startFrame = requestAnimationFrame(() => {
      expandFrame = requestAnimationFrame(() => {
        setIsWidthExpanded(true);
      });
    });

    return () => {
      cancelAnimationFrame(startFrame);
      cancelAnimationFrame(expandFrame);
      setIsWidthExpanded(false);
    };
  }, [isOpen]);

  return isOpen && isWidthExpanded;
}

export const CHAT_SIDE_PANEL_SHELL_CLASS =
  'flex h-dvh shrink-0 flex-col overflow-hidden border-l border-border/50 bg-sidebar transition-[width] duration-300 ease-[cubic-bezier(0.32,0.72,0,1)]';
